import { Controller } from "@hotwired/stimulus"

// Enricher Config Controller
// Shows/hides provider-specific configuration panels based on enricher selection
export default class extends Controller {
  static targets = ["enricherSelect", "apifyConfig"]

  connect() {
    // Show/hide config based on initial selection
    if (this.hasEnricherSelectTarget) {
      this.updateConfigVisibility(this.enricherSelectTarget.value)
    }
  }

  enricherChanged(event) {
    this.updateConfigVisibility(event.target.value)
  }

  updateConfigVisibility(enricherType) {
    // Show Apify config only when apify_leads_finder is selected
    if (this.hasApifyConfigTarget) {
      if (enricherType === "apify_leads_finder") {
        this.apifyConfigTarget.classList.remove("hidden")
      } else {
        this.apifyConfigTarget.classList.add("hidden")
      }
    }
  }
}
